import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { FaSearch } from 'react-icons/fa';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { LuArrowUpDown } from 'react-icons/lu';
import { useDispatch } from 'react-redux';
import { setAccountDetailsModalTriggerRedux, setCurrentPage, setDocumentsModalTriggerRedux, setExpertiseTriggerRedux } from '../../feature/userData/userData';
import videoIcon from '../../media/images/shortLogo.ico'
import './tipsAndTricks.scss'
import TipsTricksVideo from '../../component/tipsTricksVideo/tipsTricksVideo';

const TipsAndTricks = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        dispatch(setCurrentPage("Tips & Tricks"));
    }, [])

    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    const [iframeDimensions, setIframeDimensions] = useState({ width: 560, height: 289 });

    const calculateIframeSize = () => {
        const screenWidth = window.innerWidth;
        let width, height;
        if (screenWidth >= 1100) {
            width = 1080;
            height = 558;
        } else if (screenWidth >= 780) {
            width = 780;
            height = 403;
        } else if (screenWidth >= 560) {
            width = 560;
            height = 289;
        } else {
            width = 320;
            height = 165;
        }

        setIframeDimensions({ width, height });
    };

    useEffect(() => {
        // Adjust iframe size on window resize
        calculateIframeSize();
        window.addEventListener("resize", calculateIframeSize);

        return () => {
            window.removeEventListener("resize", calculateIframeSize);
        };
    }, []);

    let videoUrlCo = "https://app.vidzflow.com/v/AQuvMqVUlD?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen"

    const [videoUrl, setVideoUrl] = useState('');
    const [videoObj, setVideoObj] = useState({});

    const tipsAndTricksArr = [
        {
            dataVideoId: '24745',
            title: 'How to do signup in Chilll',
            url: 'https://app.vidzflow.com/v/PiJuVVEM5Z?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93333333',
        },
        {
            dataVideoId: '24670',
            title: 'How to draw on customer screen',
            url: 'https://app.vidzflow.com/v/XU6jjjeTRM?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93535354',
        },
        {
            dataVideoId: '24623',
            title: 'How to add expertise',
            url: 'https://app.vidzflow.com/v/AQuvMqVUlD?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.94117647',
        },
        {
            dataVideoId: '24660',
            title: 'How to add documents',
            url: 'https://app.vidzflow.com/v/uAUFC7hYDy?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.94320487',
        },
        {
            dataVideoId: '24672',
            title: 'How to search parts and manuals for device',
            url: 'https://app.vidzflow.com/v/Ct3Dq3fUaP?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93724696',
        },
        {
            dataVideoId: '24673',
            title: 'How to add shopping item',
            url: 'https://app.vidzflow.com/v/b78qxVPUME?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93145161',
        },
        {
            dataVideoId: '24662',
            title: 'How to add your credit cards',
            url: 'https://app.vidzflow.com/v/ZN0flcG9dp?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.92943548',
        },
        {
            dataVideoId: '24663',
            title: 'How to connect with your own customers',
            url: 'https://app.vidzflow.com/v/xhlCs3ui92?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93346774',
        },
        {
            dataVideoId: '24661',
            title: 'How to accept jobs real-time',
            url: 'https://app.vidzflow.com/v/3E7m2gA3jh?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.92957746',
        },
        {
            dataVideoId: '24664',
            title: 'How to buy subscriptions',
            url: 'https://app.vidzflow.com/v/uq226Mwpbc?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.93535354',
        },
        {
            dataVideoId: '25653',
            title: 'How to allow camera and mic permissions to Chilll video call',
            url: 'https://app.vidzflow.com/v/ZfwCs2Vo80?dq=576&ap=true&muted=true&loop=true&ctp=false&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
            aspectRatio: '1.80377358',
        },
    ]

    return (
        <>
            <div className='row mx-0'>
                <div className='col-12 px-2 pe-lg-3'>
                    {/* <>
                        <div className="row w-100 mx-0 mt-1">
                            <div className="col-md-4 pe-md-3 px-0 mt-2 ">
                                <div className="h-100 mx-0 row">
                                    <div className="col-12 px-0 ">
                                        <div className="row mx-0 w-100 bg-light h-100 ">
                                            <div className="col-12 mb-2 p-3 h-100">
                                                <div className="row mx-0 h-100">
                                                    <div className='col-12 px-0 d-flex'>
                                                        <div className="align-items-center d-flex justify-content-center pe-2">
                                                            <div
                                                                className="align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black "
                                                                style={{
                                                                    minHeight: "50px",
                                                                    minWidth: "50px",
                                                                }}>
                                                                <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex flex-column justify-content-between">
                                                            <div>
                                                                <div className="fs-4 mb-2 row fw-bold">
                                                                    <div className="col-12 ">
                                                                        <span className="fw-500 text-black">
                                                                            {"Add your expertise"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="fs-7 mb-2 row text-black">
                                                                    <div className="col-12">
                                                                        <span>{`Please add your expertise to be able to take on service requests of your speciality.`}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex font-w500 fs-7 row">
                                                                <div className="col-md-8 pe-2 " style={{}}>
                                                                    <div className="d-flex">
                                                                        <div
                                                                            onClick={() => {
                                                                                navigate("/userProfile");
                                                                                dispatch(setExpertiseTriggerRedux(true));
                                                                            }}
                                                                            className="align-items-center font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2">
                                                                            <span>{"Add expertise"} </span>
                                                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-4"></div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 pe-md-3 px-0 mt-2 ">
                                <div className="h-100 mx-0 row">
                                    <div className="col-12 px-0 ">
                                        <div className="row mx-0 w-100 bg-light h-100 ">
                                            <div className="col-12 mb-2 p-3 h-100">
                                                <div className="row mx-0 h-100">
                                                    <div className='col-12 px-0 d-flex'>
                                                        <div className="align-items-center d-flex justify-content-center pe-2">
                                                            <div
                                                                className="align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black "
                                                                style={{
                                                                    minHeight: "50px",
                                                                    minWidth: "50px",
                                                                }}>
                                                                <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex flex-column justify-content-between">
                                                            <div>
                                                                <div className="fs-4 mb-2 row fw-bold">
                                                                    <div className="col-12 ">
                                                                        <span className="fw-500 text-black">
                                                                            {"Add documents"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="fs-7 mb-2 row text-black">
                                                                    <div className="col-12">
                                                                        <span>{`If you attach your licenses, we'll verify them to make your profile stand out.`}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex font-w500 fs-7 row">
                                                                <div className="col-md-8 pe-2 " style={{}}>
                                                                    <div className="d-flex">
                                                                        <div
                                                                            onClick={() => {
                                                                                navigate("/userProfile");
                                                                                dispatch(setDocumentsModalTriggerRedux(true));
                                                                            }}
                                                                            className="align-items-center font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2">
                                                                            <span>{"Add document"} </span>
                                                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-4"></div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 px-0  mt-2 ">
                                <div className="h-100 mx-0 row">
                                    <div className="col-12 px-0 ">
                                        <div className="row mx-0 w-100 bg-light h-100 ">
                                            <div className="col-12 mb-2 p-3 h-100">
                                                <div className="row mx-0 h-100">
                                                    <div className='col-12 px-0 d-flex'>
                                                        <div className="align-items-center d-flex justify-content-center pe-2">
                                                            <div
                                                                className="align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black "
                                                                style={{
                                                                    minHeight: "50px",
                                                                    minWidth: "50px",
                                                                }}>
                                                                <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex flex-column justify-content-between">
                                                            <div>
                                                                <div className="fs-4 mb-2 row fw-bold">
                                                                    <div className="col-12 ">
                                                                        <span className="fw-500 text-black">
                                                                            {"Change your photo"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="fs-7 mb-2 row text-black">
                                                                    <div className="col-12">
                                                                        <span>{`Do you know that adding your photo increases your chances of getting a job?`}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex font-w500 fs-7 row">
                                                                <div className="col-md-8 pe-2 " style={{}}>
                                                                    <div className="d-flex">
                                                                        <div
                                                                            onClick={() => {
                                                                                navigate("/userProfile");
                                                                                dispatch(setAccountDetailsModalTriggerRedux(true));
                                                                            }}
                                                                            className="align-items-center font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2">
                                                                            <span>{"Change photo"} </span>
                                                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-4"></div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </> */}

                    <>
                        <div className="row mx-0 border mt-2 mt-md-3" style={{ minHeight: "300px" }}>
                            <div className='col-12 p-3'>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                        <div className='row mx-0'>

                                            <div className='col-md-6 px-0 d-flex align-items-center justify-content-start'>
                                                <span className='text-black fw-bold fs-4'>{"More useful video tutorials"}</span>
                                            </div>

                                            {/* Searching sorting */}
                                            {/* <div className='col-md-6 px-0 d-flex justify-content-end align-items-center'>
                                                <span className="fs-6 p-2 d-flex align-items-center justify-content-end">
                                                    <span
                                                        className="fs-6 p-2 d-flex align-items-center"
                                                        style={{
                                                            border: "1px solid lightgray",
                                                            borderRadius: "4px",
                                                        }}>
                                                        <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                        <input
                                                            placeholder="Search"
                                                            style={{ border: "0px", width: "100%" }}
                                                        // onChange={handleSearch}
                                                        // value={searchValue}
                                                        />
                                                    </span>
                                                    <span className="fs-5 p-2 d-flex align-items-center">
                                                        <LuArrowUpDown
                                                            className="pointer"
                                                            style={{ marginRight: "4px", color: "black" }}
                                                        // onClick={handleOpenFiltreBox}
                                                        />
                                                        <span
                                                            className="fs-6  pointer"
                                                            style={{ position: "relative" }}
                                                        // onClick={handleOpenFiltreBox}
                                                        >
                                                            {true && "Date: Newset first"}
                                                            {false && "Date: Oldest first"}
                                                            &nbsp;
                                                            {true ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                            <span
                                                                className={`${false ? "" : "d-none"} p-3`}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "26px",
                                                                    width: "152px",

                                                                    border: "1px solid lightgray",
                                                                    background: "white",
                                                                    right: "0",
                                                                    boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                }}>
                                                                <div className="row">
                                                                    <div
                                                                        className={`${true ? "dt" : ""
                                                                            } d-flex justify-content-start m-1 pointer `}
                                                                        onClick={() => {
                                                                            // handleSetFiltreValue(1);
                                                                        }}>
                                                                        Date: Newest first
                                                                    </div>
                                                                    <div
                                                                        className={`${true ? "dt" : ""
                                                                            } d-flex justify-content-start m-1 pointer`}
                                                                        onClick={() => {
                                                                            // handleSetFiltreValue(2);
                                                                        }}>
                                                                        Date: Oldest first
                                                                    </div>

                                                                </div>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </div> */}
                                        </div>

                                        <div className='row mx-0 mt-1'>
                                            <div className='col-12 px-0'>

                                                <div className='row mx-0'>
                                                    {tipsAndTricksArr.map((item, index) => {
                                                        return (
                                                            <div key={index} className='col-md-6 px-0 pe-md-3 mt-md-3 mt-2 ' >
                                                                <div className='row mx-0 border  cursor-pointer tipTricksVideoContainer'
                                                                    onClick={() => {
                                                                        openModal();
                                                                        setVideoUrl(item.url)
                                                                        setVideoObj(item)
                                                                    }}
                                                                    style={{ minHeight: '80px' }}
                                                                >
                                                                    <div className='col-4 px-0 bg-light d-flex justify-content-center align-items-center' >
                                                                        {/* <i className="bi bi-play-fill fs-1 text-black"></i> */}
                                                                        <div className='p-2 d-flex justify-content-center align-items-center rounded-circle video-icon' style={{ height: '50px', width: '50px', }}>
                                                                            <img src={videoIcon} className='ms-1' alt="" style={{ height: '27px', width: '27px', }} />
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-8 d-flex align-items-center p-3'>
                                                                        <span className='font-w600 fs-5 text-black'>{item.title}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>

            <TipsTricksVideo videoObj={videoObj} openModal={isModalOpen} onClose={closeModal} />


           {/* <div>
                {isModalOpen && (
                    <div
                        className='position-fixed d-flex align-items-center justify-content-center'
                        style={{
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgb(36 31 31 / 80%)",
                            zIndex: 1000,
                        }}
                        onClick={closeModal}
                    >
                        <button
                            onClick={closeModal}
                            className='cursor-pointer text-white position-absolute font-w600'
                            style={{
                                top: "15px",
                                right: "15px",
                                background: "transparent",
                                border: "none",
                                fontSize: "40px",
                            }}
                        >
                            &times;
                        </button>

                        <div
                            className='position-relative overflow-hidden d-flex align-items-center justify-content-center'
                            style={{
                                backgroundColor: "white",
                                borderRadius: "10px",
                                boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                style={{
                                    width: `${iframeDimensions.width}px`,
                                    height: `${iframeDimensions.height}px`,
                                }}
                            >
                                <iframe
                                    width={iframeDimensions.width}
                                    height={iframeDimensions.height}
                                    src="https://app.vidzflow.com/v/AQuvMqVUlD?dq=576&ap=true&muted=true&loop=true&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen"
                                    title="Chilll Signup"
                                    frameBorder="0"
                                    scrolling="no"
                                    allow="fullscreen"
                                    style={{ borderRadius: "10px" }}
                                ></iframe>
                            </div>
                        </div>
                    </div>
                )}
            </div> */}

        </>
    )
}

export default TipsAndTricks